import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';

export enum TagVariant {
  Error = 'error',
  Attention = 'attention',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',

  HighAlert = 'high-alert',
  Elevated = 'elevated',
  Audit = 'audit',
  HotWeather = 'hot-weather',
  ColdWeather = 'cold-weather',
}

@Component({
  selector: 'dr-ops-stream-ui-app-tag',
  standalone: true,
  templateUrl: './app-tag.component.html',
  styleUrl: './app-tag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppTagComponent {
  readonly variant = input.required<TagVariant>();
  readonly label = input.required<string>();
  readonly size = input<'md' | 'sm'>('md');
  readonly tagVariant = TagVariant;
}
